import React, { useState } from 'react'

import { IProps } from './interfaces'
import Styles from './styles.module.scss'

export const LazyImage = ({ width, height, src, alt, containerClassName, ...others }: IProps): JSX.Element => {
  const [loadingDone, setLoadingDone] = useState<boolean>(false)
  const containerClasses: string[] = [Styles.imageContainer]
  if (containerClassName) containerClasses.push(containerClassName)

  return (
    <div className={containerClasses.join(' ')} style={{ width: width || '100%', height: height || '100%' }}>
      <img
        {...others}
        loading="lazy"
        src={src}
        alt={alt}
        width={width || '100%'}
        height={height || '100%'}
        onLoad={(): void => setLoadingDone(true)}
        className={loadingDone ? Styles.imageLoaded : Styles.imageLoading}
        data-image-state={loadingDone ? 'loaded' : 'loading'}
      />
    </div>
  )
}

// TODO cypress screenshot should check for all lazy loading images to have loaded
// make a difference between images not on screen which will never load, and those that are loading
